import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import agreeToChargeCardEN from './locales/en/agreeToChargeCard.json';
import commonEN from './locales/en/common.json';
import footerEn from './locales/en/footer.json';
import orderSummaryEN from './locales/en/orderSummary.json';
import billingInfoEN from './locales/en/billingInfo.json';
import paymentInfoEN from './locales/en/paymentInfo.json';
import pageNotFoundEN from './locales/en/404.json';
import orderConfirmationEN from './locales/en/orderConfirmation.json';

const resources = {
	en: {
		agreeToChargeCard: agreeToChargeCardEN,
		common: commonEN,
		footer: footerEn,
		orderSummary: orderSummaryEN,
		billingInfo: billingInfoEN,
		paymentInfo: paymentInfoEN,
		pageNotFound: pageNotFoundEN,
		orderConfirmation: orderConfirmationEN
	}
};

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: 'en',
		debug: false,
		initImmediate: false,
		ns: ['paylink-translation'],
		defaultNS: 'paylink-translation',
		react: {
			useSuspense: false,
			wait: true
		},
		resources,
		interpolation: {
			escapeValue: false
		}
	});
